<template lang="pug">
  .b-user-menu(v-if="user" :class="{ opened: menuIsOpened }")
    HeaderUserNotifications
    ._btn(@click="menuIsOpened = !menuIsOpened")
      UserAvatar(:user="user" :class="{ impersonator: user.isImpersonation }")._icon
      span.arrow._arrow
    CommonDropdown._dropdown(:items="userMenuItems" :isOpened="menuIsOpened")
</template>

<script>
import user from '@/model/user';
import auth from '@/model/auth';

import CommonDropdown from '@/components/CommonDropdown.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import HeaderUserNotifications from '@/components/HeaderUserNotifications.vue';

export default {
  name: 'TheUserDropdown',
  components: { UserAvatar, CommonDropdown, HeaderUserNotifications },
  data() {
    return {
      menuIsOpened: false,
    };
  },
  computed: {
    user() { return this.$store.state.auth.user; },
    isAdmin() { return this.user.roles.includes('ROLE_ADMIN'); },
    isObserver() { return this.user.roles.includes('ROLE_OBSERVER'); },
    userMenuItems() {
      const items = [
        /* eslint-disable no-multi-spaces */
        { text: 'Аккаунт',      icon: 'user-small',     route: { name: 'account' } },
        { text: 'Партнерство',  icon: 'members',        route: { name: 'affiliate-main' } },
        { text: 'Настройки',    icon: 'setting',        route: { name: 'notification-settings' } },
        { text: 'Уведомления',  icon: 'notifications',  route: { name: 'notifications' } },
        { text: 'Выход',        icon: 'exit',           handler: this.logoutUser },
        /* eslint-enable */
      ];

      if (this.isAdmin || this.isObserver) {
        items.unshift({
          text: 'Список пользователей',
          icon: 'list-ul',
          route: { name: 'admin-users' },
        });
      }

      if (this.user.isImpersonation) {
        items.unshift({
          text: 'Опять стать админом',
          icon: 'exit',
          handler: () => { user.impersonate(); },
        });
      }

      return items;
    },
  },
  methods: {
    closeMenu(e) {
      if (!this.$el.contains(e.target)) {
        this.menuIsOpened = false;
      }
    },
    logoutUser() {
      auth.logout().then(() => {
        auth.goToRouteAfterLogin(this.$route.fullPath);
        this.$router.push({ name: 'auth-login' });
      });
    },
  },
  mounted() {
    document.addEventListener('click', this.closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu);
  },
};
</script>

<style scoped lang="scss">
.user-menu {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;

  &__btn {
    display: flex;
    align-items: center;
    padding: 9px;
    border-radius: 6px;
    background-color: rgba(40, 140, 228, 0.58);
    transition: background-color 0.3s;
    cursor: pointer;
  }

  &.opened &__arrow {
    transform: rotate(180deg);
  }

  &.opened &__btn {
    background-color: #217FD1;
  }

  &__arrow {
    display: block;
    width: 24px;
    height: 24px;
    background-image: url(../assets/img/svg/down.svg);
    background-repeat: no-repeat;
    background-size: cover;
    transition: transform 0.2s;
  }

  &__icon {
    margin-right: 8px;
    width: 36px;
    height: 36px;

    &.impersonator {
      border-color: #ffd500;
    }
  }
  &__dropdown {
    top: 80px;
    right: 0;
  }

  @media (max-width: 576px) {
    &__icon {
      margin-right: 3px;
    }
  }

  @media (max-width: 500px) {
    &__icon {
      margin-right: 0;
    }
    &__arrow {
      display: none;
    }
  }
}
</style>
